import React from 'react';
import SMSpaceResource from 'resources/SMSpaceResource';
import SMRoomBlockResource from 'resources/SMRoomBlockResource';
import SMRoomResource from 'resources/SMRoomResource';
import SMConst from 'lib/SMConst';
import SMFormCheckBox from 'components/dashboard/form/SMFormCheckBox';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormSpaceSelectBox from 'components/dashboard/form/SMFormSpaceSelectBox';
import SMFormRoomSelectBox from 'components/dashboard/form/SMFormRoomSelectBox';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import sprintf from 'sprintf';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMOScheduleEditView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      owner: this.props.owner.attributes,
      spaceId: this.props.initialSpaceId,
      roomId: this.props.initialRoomId,
      room: null,
      error: null,
      startedDate: this.props.initialStartedDate,
      endedDate: this.props.initialEndedDate,
      startedHour: null,
      endedHour: null,
      saveButtonStatus: true,
      isAllDay: true,
    };
  }

  componentDidMount() {
    const self = this;
    $(".js-datepicker").datepicker({
      minDate: 0,
      dateFormat: "yy/mm/dd",
      onClose: function (date, inst) {
        if (this.name == 'started_date') {
          self.setState({ startedDate: date});
        } else if (this.name == 'ended_date') {
          self.setState({ endedDate: date});
        }
      },
    });
    
    if (this.props.scheduleId) {
      $(this.refs.form).startLoading();
      this.getRoomBlockResource(this.props.scheduleId);
    }
  }

  getRoomBlockResource(id) {
    SMRoomBlockResource.getBlock(id, (data, error, xhr)=> {
      this.setState({
        startedDate: data.start_date_text,
        endedDate: data.end_date_text,
        startedHour: data.start_hour_text,
        endedHour: data.end_hour_text,
        isAllDay: data.is_all_day,
        spaceId: data.space.username,
        roomId: data.room.uid,
      });
      $(this.refs.form).stopLoading();
    });
  }
  
  getSpaceResource(value) {
    SMSpaceResource.getSpace(value, (data, error, xhr)=> {
      this.setState({
        spaceId: value,
        space: data,
        roomId: "",
        room: null,
      });
    });
  }

  getRoomResource(value) {
    SMRoomResource.getRoom(value, (data, error, xhr)=> {
      this.setState({
        room: data,
        roomId: value,
      });
    });
  }
  
  roomSelectBoxDidChangeValue(value) {
    this.getRoomResource(value);
  }
  
  spaceSelectBoxDidChangeValue(value) {
    this.getSpaceResource(value);
  }

  // event observer
  handleClickCancelButton(e) {
    location.href = Routes.owner_dashboard_calendars_path(this.state.owner.username);
  }

  handleClickSubmitButton(e) {
    e.preventDefault();
    this.trackPageEvent('od submit block_reservation');
    this.setState({ saveButtonStatus: false });
    
    const startedAt = new Date(Date.parse(this.state.isAllDay ? this.state.startedDate : `${this.state.startedDate} ${this.state.startedHour}`));
    let endedAt = new Date(Date.parse(this.state.isAllDay ? this.state.endedDate : `${this.state.endedDate} ${this.state.endedHour}`));
    let error;
    let data = {
      room_id: this.state.roomId,
      schedule_type: SMConst.ScheduleType.Disable,
    };
    
    if (startedAt.getTime() > endedAt.getTime()) {
      error = '予約をブロックする終了時間を開始時間の前に指定することはできません。';
    } else if (startedAt.getTime() == endedAt.getTime()) {
      if (!this.state.isAllDay) {
        error = '予約をブロックする終了時間を開始時間の前に指定することはできません。';
      }
    }
    
    if (error) {
      this.setState({ 
        error: error,
        saveButtonStatus: true,
      });
      return;
    }
    
    if (this.state.isAllDay) {
      endedAt.setDate(endedAt.getDate() + 1);
      data.is_all_day = 1;
    } else {
      data.start_hour = startedAt.getHours();
      data.end_hour = endedAt.getHours();
    }
    data.start_day = sprintf("%d%02d%02d", startedAt.getFullYear(), startedAt.getMonth()+1, startedAt.getDate());
    data.end_day = sprintf("%d%02d%02d", endedAt.getFullYear(), endedAt.getMonth()+1, endedAt.getDate());
    
    if (this.props.scheduleId) {
      SMRoomBlockResource.updateBlock(this.props.scheduleId, data, {}, this.responseHandler.bind(this));
    } else {
      SMRoomBlockResource.postBlock(data, {}, this.responseHandler.bind(this));
    }
    $(this.refs.form).startLoading();
  }

  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }
  
  responseHandler(room_block, error, xhr) {
    if (xhr.status == 200 || xhr.status == 201) {
      location.href = Routes.owner_dashboard_calendars_path(this.state.owner.username);
    } else if (xhr.status == 400) {
      $(this.refs.form).stopLoading();
      const errors = xhr.responseJSON.errors;
      this.setState({ errors: errors });
    } else {
      $(this.refs.form).stopLoading();
    }
    
    this.setState({ saveButtonStatus: true });
  }

  radioButtonDidChangeValue(e) {
    if (this.props.delegate && typeof this.props.delegate.radioButtonDidChangeValue === 'function'){
      this.props.delegate.radioButtonDidChangeValue(e);
    }
  }
  
  checkBoxDidChangeValue(e) {
    this.setState({
      isAllDay: e.currentTarget.checked,
    });
  }
  
  selectBoxDidChangeValue(e) {
    if (e.currentTarget.name == 'started_hour') {
      this.setState({ startedHour: e.currentTarget.value });
    } else if (e.currentTarget.name == 'ended_hour') {
      this.setState({ endedHour: e.currentTarget.value });
    }
  }
   
  deleteItemDidClick(e) {
    e.preventDefault();
    if (window.confirm(I18n.t("dashboard.notice_000003"))) {
      SMRoomBlockResource.deleteBlock(this.props.scheduleId, {}, (data, error, xhr)=> {
        if (xhr.status == 204) {
          location.href = Routes.owner_dashboard_calendars_path(this.state.owner.username);
        }
      });
    }
  }

  canSubmitButton() {
    if (this.state.spaceId && this.state.roomId && 
        this.state.startedDate && this.state.endedDate &&
        (this.state.isAllDay || (this.state.startedHour && this.state.endedHour)) &&
        this.state.saveButtonStatus) {
      return true;
    } else {
      return false;
    }
  }

  
  renderStartHour() {
    if (this.state.isAllDay) return null;
    
    let selectBoxItems = [];
    selectBoxItems.push({value: null, label: ''});
    for (let i = 0; i <= 24; i++) {
      let checkinTimeZero = i.toString() + ":00";
      selectBoxItems.push({ value: checkinTimeZero, label: checkinTimeZero });
    }
    
    return(
      <span className="form-select__inner ml5">
        <label className="form-select">
          <SMFormSelectBox
            name='started_hour'
            items={selectBoxItems}
            selectedValue={this.state.startedHour}
            delegate={this}
            options={{className: 'w110' }} />
        </label>
      </span>
    );
  }

  renderEndHour() {
    if (this.state.isAllDay) return null;
    
    let selectBoxItems = [];
    selectBoxItems.push({value: null, label: ''});
    for (let i = 0; i <= 24; i++) {
      let checkinTimeZero = i.toString() + ":00";
      selectBoxItems.push({ value: checkinTimeZero, label: checkinTimeZero });
    }     
    return(
      <span className="form-select__inner ml5">
        <label className="form-select">
          <SMFormSelectBox
            name='ended_hour'
            items={selectBoxItems}
            selectedValue={this.state.endedHour}
            delegate={this}
            options={{className: 'w110' }} />
        </label>
      </span>
    );
  }

  render() {
    return (
      <div className="dashboard-container clearfix mb30">
        <div className="dashboard-maincol" ref="formContent">
          <h2 className="dashboard-title mb30">
            {I18n.t("dashboard.label_000160")}
            {this.props.action == 'edit' &&
              <a href="#" onClick={(event) => this.deleteItemDidClick(event)} className="button button-gray dashboard-title__button"><i className="fa fa-trash-o mr5"></i>削除する</a>
            }
          </h2>

          <form ref='form'>
            <input type='hidden' name='room_id' value={this.state.roomId} />
            <div>
              <h3 className="dashboard-title2 mb20">ブロック設定</h3>
              <table className="dashboard-form-table mb50">
                <tbody>
                  {this.props.action == 'new' &&
                    <tr>
                      <th>ブロック理由<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
                      <td>
                        <input
                          type="radio"
                          value={SMConst.ReservationBlockType.Unavailable}
                          id="form-radio05__01"
                          name="is_block"
                          checked={true}
                          onChange={(event) => this.radioButtonDidChangeValue(event)} />
                        <label htmlFor="form-radio05__01" className="form-radio w150">利用不可</label>
                        <p className='mb10'></p>
                        <input
                          type="radio"
                          value={SMConst.ReservationBlockType.Manual}
                          id="form-radio05__02"
                          name="is_block"
                          checked={false}
                          onChange={(event) => this.radioButtonDidChangeValue(event)} />
                        <label htmlFor="form-radio05__02" className="form-radio">スペースマーケット以外の予約</label>
                        <p className='dashboard-title__supplement mt10 mb10'>任意の予約情報をスペースマーケットで管理することができます。入力により手数料が発生することはありません。詳しくは <a href={SMAppHelper.helpUrl(SMConst.OwnerHelpPageID.ManualReservation)} target='_blank'>{I18n.t("dashboard.label_000142")}</a> をご覧ください。</p>
                      </td>
                    </tr>
                  }

                  <tr>
                    <th>日時<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
                    <td>
                      <p className="mb10">
                        <SMFormCheckBox name="is_daily" value={true} checked={this.state.isAllDay} id="form-checkbox03__01" delegate={this} />
                        <label htmlFor="form-checkbox03__01" className="form-checkbox w200">終日</label>
                      </p>

                      <SMFormTextField
                        name="started_date"
                        value={this.state.startedDate}
                        options={{ className: 'w110 js-datepicker' }}
                        placeholderText='20151201'
                        delegate={this} />
                      {this.renderStartHour()}
                      <span className="ml5 mr5">〜</span>
                      <SMFormTextField
                        name="ended_date"
                        value={this.state.endedDate}
                        options={{ className: 'w110 js-datepicker' }}
                        placeholderText='20151201'
                        delegate={this} />
                      {this.renderEndHour()}
                      {this.state.error && <span className="message-important ml10">{this.state.error}</span>}
                      <p className="mt10">
                        <a href={Routes.owner_dashboard_calendars_path(this.state.owner.username, {
                          space_id: this.state.spaceId,
                          room_id: this.state.roomId
                        })} target="_blank" className="link-hover-border">予約カレンダーを確認</a>
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <th>会場・スペース名<span className="icon-form icon-form__required dashboard-form-table__icon">必須</span></th>
                    <td>
                      <span className="form-select__inner mr10">
                        <label className="form-select">
                          <SMFormSpaceSelectBox 
                            ownerId={this.state.owner.username}
                            spaceId={this.state.spaceId} 
                            options={{ className: "w200" }}
                            delegate={this} />
                        </label>
                      </span>
                      <span className="form-select__inner">
                        <label className="form-select">
                          <SMFormRoomSelectBox 
                            ownerId={this.state.owner.username}
                            spaceId={this.state.spaceId} 
                            roomId={this.state.roomId} 
                            options={{ className: "w200" }}
                            delegate={this} 
                          />
                        </label>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>  
            </div>

            <div className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
              <input data-href={Routes.owner_dashboard_reservations_path(this.state.owner.username)}
                className="button-gray maincol-buttonarea__button"
                type="button"
                value={I18n.t("dashboard.label_000152")} 
                onClick={(event) => this.handleClickCancelButton(event)} />

              <input data-href={Routes.owner_dashboard_reservations_path(this.state.owner.username)}
                className={this.canSubmitButton() ? "button-green maincol-buttonarea__button" : "button-disabled maincol-buttonarea__button"}
                disabled={!this.canSubmitButton()}
                type="submit"
                value={I18n.t("dashboard.label_000160")}
                onClick={(event) => this.handleClickSubmitButton(event)} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default SMOScheduleEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOScheduleEditView.jsx